export default "__VITE_ASSET__BHhX5Fp2__"